/**
 * インターンシップ入力ページで、確認画面から戻ったときに
 * 申し込みフォーム（#apply）へスクロールする。
 */
class InternshipApplyScroll {
  constructor(opt = {}) {
    this.targetId = opt.targetId || 'apply';
    this.target = document.getElementById(this.targetId);
    if (!this.target) return;
    if (!this.isConfirmReferrer()) return;

    const run = () => this.scrollToApply();
    if (document.readyState === 'complete') {
      run();
    } else {
      window.addEventListener('load', run, { once: true });
    }
  }

  isConfirmReferrer() {
    const ref = document.referrer;
    if (!ref) return false;

    let url;
    try {
      url = new URL(ref);
    } catch (e) {
      return false;
    }

    if (url.origin !== window.location.origin) return false;

    const path = url.pathname;
    return (
      path.indexOf('entry-confirm') !== -1 ||
      path.indexOf('internship-confirm') !== -1 ||
      (path.indexOf('internship') !== -1 && path.indexOf('confirm') !== -1)
    );
  }

  scrollToApply() {
    const path = window.location.pathname + window.location.search;
    if (window.location.hash !== '#' + this.targetId) {
      history.replaceState(null, '', path + '#' + this.targetId);
    }
    this.target.scrollIntoView({ block: 'start' });
  }
}
